// importing bootstrap here wont be able to use in other components for eg. bo-login-popup.
// bootstrap need to be imported in every page, not here in the header
import Vue from "vue";
import moment from "moment";
import { boDatatableNewMixin } from "@/v2/mixins/bo-datatable-new.js";

Vue.component("bo-login-popup", require("js/frontend/modules/bo-login-popup.vue").default);
Vue.component("bo-company-selector-popup", require("js/frontend/modules/bo-company-selector-popup.vue").default);
Vue.component("bo-cell-button-popup", require("@/v2/components/bo-cell-button-popup.vue").default);
Vue.component("bo-category", require("@/v2/components/header/bo-category.vue").default);
Vue.component("bo-return-search", require("js/frontend/components/return/bo-return-search.vue").default);
Vue.component("bo-return-popup", require("js/frontend/components/return/bo-return-popup.vue").default);
Vue.component("bo-navbar", require("@/v2/components/header/bo-navbar.vue").default);
Vue.component("bo-announcement-bar", require("@/v2/components/bo-announcement-bar.vue").default);
Vue.component("bo-login", require("js/frontend/components/bo-login.vue").default);
Vue.component("bo-lucene-search", require("js/frontend/components/bo-lucene-search.vue").default);
Vue.component("bo-mobile-lucene-search", require("js/frontend/components/bo-mobile-lucene-search.vue").default);
Vue.component("bo-cell-toggle", require("@/v2/components/bo-cell-toggle.vue").default);
Vue.component("bo-datatable-new", require("@/v2/components/bo-datatable-new.vue").default);
Vue.component("bo-popup-modal", require("@/v2/components/bo-popup-modal.vue").default);

const loginApp = new Vue({
    el: "#login-app",
    mixins: [
        boDatatableNewMixin,
    ],
    data() {
        return {
            showPopup: false,
            selectedProduct: null,
            selectedProductSerialNumber: null,
            selectedProductBatch: null,
            showLoginPopup: false,
            whatsappNumber: null,
            displayBarEnable: false,
            returnMode: false,
            catalogRoute: null,
            returnCatalogRoute: null,
            currentRoute: null,
            authUser: null,
            openLanguagesDropdown: false,

            // cart error
            cartErrorMessages: null,
            cartErrorPopup: false,
            cartErrorTitle: window.bo?.generalTranslations?.error ?? "Error",
            selectedCartErrorTab: "error",
            cartErrorMessageColumns: this.boDatatableProcessColumns([
                {
                    id: "error_message",
                    label: window.bo?.generalTranslations?.error_message ?? 'Error Message',
                    type: "text",
                    editable: false,
                    orderable: false,
                    searchable: true,
                    additional_classes: "cart-error-message-col",
                },
                {
                    id: "updated_at",
                    label: window.bo?.generalTranslations?.updated_at ?? 'Updated At  ',
                    type: "datetime",
                    editable: false,
                    orderable: false,
                    searchable: true,
                    withTime: true,
                    additional_classes: "cart-error-date-col",
                },
            ]),
            dateFormat: window.bo?.dateFormat ?? "DD MMM YYYY",
            timeFormat: window.bo?.timeFormat ?? "hh:mm A",
            momentLocale: window.bo?.generalTranslations?.momentLocale ?? "en_US",
            generalTranslations: window.bo?.generalTranslations ?? {},
        };
    },

    mounted() {
        this.catalogRoute = window.bo?.catalogRoute;
        this.returnCatalogRoute = window.bo?.returnCatalogRoute;
        this.currentRoute = window.bo?.currentRoute;
        this.authUser = window.bo?.authUser;

        if ("" == window.bo_whatsapp) {
        } else {
            axios
                .get(window.bo_whatsapp)
                .then((response) => {
                    this.whatsappNumber = response.data;
                })
                .catch((error) => {});
        }
        if (!window.EventBus) {
            window.EventBus = new Vue();
        }
        window.EventBus.$on("displayBarEnable", (displaybar) => (this.displayBarEnable = displaybar));

        if (this.currentRoute && this.returnCatalogRoute && this.currentRoute.includes(this.returnCatalogRoute)) {
            this.returnMode = true;
        }

        window.addEventListener("cart-error-updated", (e) => {
            this.cartErrorMessages = [];
            this.cartErrorMessages.splice(
                0,
                this.cartErrorMessages.length,
                ...e.detail
            );
        });

        const syncMobileHeaderHeight = () => {
            const header = this.$el;
            if (header) {
                document.documentElement.style.setProperty(
                    "--mobile-header-height",
                    `${Math.ceil(header.getBoundingClientRect().height)}px`
                );
            }
        };
        this.$nextTick(syncMobileHeaderHeight);
        if (typeof ResizeObserver !== "undefined" && this.$el) {
            new ResizeObserver(syncMobileHeaderHeight).observe(this.$el);
        }
        window.addEventListener("resize", syncMobileHeaderHeight);
    },

    methods: {
        activeReturnPopup(returnResult) {
            if (returnResult.type == "document") {
                this.selectedProduct = returnResult.item.product;
                this.selectedProductSerialNumber = returnResult.serial_number;
            } else {
                this.selectedProduct = returnResult.item;
            }
            this.showPopup = true;
        },
        deactivatePopup() {
            this.showPopup = false;
            this.selectedProductSerialNumber = null;
        },
        showLoginModal() {
            this.showLoginPopup = true;
        },
        closeLoginModal() {
            this.showLoginPopup = false;
        },
        openMobileMenu() {
            const sidebar = document.getElementById("sidebar-nav");
            const backdrop = document.querySelector(".modal-back-fade");

            if (sidebar) {
                sidebar.style.width = "80%";
            }
            if (backdrop) {
                backdrop.style.width = "100%";
            }
            document.body.classList.add("modal-open");
        },
        closeMobileMenu() {
            const sidebar = document.getElementById("sidebar-nav");
            const backdrop = document.querySelector(".modal-back-fade");

            if (sidebar) {
                sidebar.style.width = "0";
            }
            if (backdrop) {
                backdrop.style.width = "0";
            }
            document.body.classList.remove("modal-open");
        },
        changeMainContainer() {
            if (this.displayBarEnable) {
                $("#app").addClass("display-bar-showed");
            } else {
                $("#app").removeClass("display-bar-showed");
            }
        },
        handleSwitchReturnMode(returnModeActive) {
            this.returnMode = returnModeActive;
            if (this.authUser) {
                if (this.returnMode) {
                    // Return mode
                    window.location.href = this.returnCatalogRoute;
                } else {
                    // Start Buying mode
                    window.location.href = this.catalogRoute;
                }
            } else {
                this.showLoginModal();
            }
        },
        isLanguagesDropdownOpen() {
            return this.openLanguagesDropdown;
        },
        toggleLanguagesDropdownOpen() {
            this.openLanguagesDropdown = !this.openLanguagesDropdown;
        },
        getErrorMessageUpdatedTime(updatedTime) {
            return moment(updatedTime).locale(this.momentLocale).format(this.dateFormat.concat(" ", this.timeFormat));
        },
        truncatedMessage($errorMessage) {
            const message = $errorMessage || "";
            const index = message.indexOf("<br>");

            if (index !== -1) {
                return message.slice(0, index) + "...";
            }

            return message;
        },
        activateCartErrorPopup() {
            this.cartErrorPopup = true;
        },
        deactivateCartErrorPopup() {
            this.cartErrorPopup = false;
        },
        updateCartErrorTitle(value) {
            this.cartErrorTitle = value;
        },
    },

    watch: {
        displayBarEnable: function (n, o) {
            this.changeMainContainer();
        },
    },
});

// const sidebarApp = new Vue({
//     el: "#sidebar",

//     data() {
//         return {
//             returnModeSidebar: true,
//             catalogRoute: window.bo.catalogRoute,
//             returnCatalogRoute: window.bo.returnCatalogRoute,
//             currentRoute: window.bo.currentRoute,
//             authUser: window.bo.authUser,
//         };
//     },
//     methods: {
//         handleSwitchReturnModeSidebar(returnModeActive) {
//             console.log("u switched");
//             this.returnModeSidebar = returnModeActive;
//             if (this.authUser) {
//                 window.location.href = returnModeActive ? this.returnCatalogRoute : this.catalogRoute;
//             }
//         },
//     },
// });
